import PropTypes from "prop-types"
import { useSelector } from "react-redux"

import Media from "components/ui/media"
import { cn } from "styles/utils"

import { AddonSlider, TitleDivider } from "../components"

import AddonMobile from "./addon-mobile"

const ExclusiveAddons = ({
  disableActions,
  setAddonInModal,
  toggleAddonModal,
  toggleDisableActions,
}) => {
  const addons = useSelector((state) => state.cart.premium_gift_offers)

  if (!addons || addons.length < 1) return null

  return (
    <Media className="mb-20" lessThan="tablet">
      <TitleDivider className="mt-36">
        <span className="text-20 font-bold">Exclusive Add-on Deal</span>
      </TitleDivider>
      <p className="text-15 leading-22 text-center font-medium">
        Save on these exclusive Add-on items!
      </p>
      <div className="relative m-0">
        <AddonSlider
          className={cn(addons.length <= 2 && "mr-0 justify-center px-10")}
        >
          {addons.map((addon) => (
            <AddonMobile
              addon={addon}
              disableActions={disableActions}
              key={`exclusive-${addon.code}-${addon.id}`}
              setAddonInModal={setAddonInModal}
              toggleAddonModal={toggleAddonModal}
              toggleDisableActions={toggleDisableActions}
            />
          ))}
        </AddonSlider>
      </div>
    </Media>
  )
}

ExclusiveAddons.propTypes = {
  disableActions: PropTypes.object,
  setAddonInModal: PropTypes.func,
  toggleAddonModal: PropTypes.func,
  toggleDisableActions: PropTypes.func,
}

export default ExclusiveAddons
